import { Button } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type BankDetailsDataFragment } from '../../../../api/fragments/BankDetailsData';
import EditBankDetailsForm from './EditBankDetailsForm';

export type EditBankFormProps = {
    updated: string;
    bank: BankDetailsDataFragment;
    offset: string;
    disabled?: boolean;
};

const EditBankForm = ({ updated, bank, offset, disabled = false }: EditBankFormProps) => {
    const { t } = useTranslation(['bankDetails']);

    const extra = useMemo(
        () =>
            !disabled && (
                <Button key="submit" form="bankForm" htmlType="submit" type="primary">
                    {t('bankDetails:actions.update')}
                </Button>
            ),
        [disabled, t]
    );

    return <EditBankDetailsForm bank={bank} disabled={disabled} extra={extra} offset={offset} updated={updated} />;
};

export default EditBankForm;
